export default __webpack_public_path__ + "static/media/cuet.dd435bcd.png";